<template>
    <AddRapportRelance />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import AddRapportRelance from "@/components/GesCom/RapportRelance/AddRapportRelance.vue";
  
    export default defineComponent({
      name: "AddRapportRelancePage",
      components: {
        
        AddRapportRelance,
      },
    });
  </script>